import { Injectable, inject } from '@angular/core';
import { LangFacade } from '@library/store/lang/lang.facade';

@Injectable({ providedIn: 'root' })
export class WebappLangFacade {
  private readonly langFacade = inject(LangFacade);

  loadLangs(locale: string): void {
    this.langFacade.loadLangs([
      { name: 'common', locale },
      { name: 'settings', locale },
      { name: 'app', locale },
      { name: 'station', locale },
      { name: 'legals', locale },
    ]);
  }
}
